import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Refill constent
   */
  {

    field: 'refillConsent',
    label:
      'I consent to an automatic refill: please charge my credit card on file, use any existing copay information, and ship my medication when it`s due.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'refillConsent', value: 'Agree' }]
    }
  }
];

export default questionsModels;